import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  "Content-Type": "application/json",
});

const handleResponse = async (response, fallbackMessage) => {
  if (!response.ok) {
    let message = fallbackMessage;
    try {
      const data = await response.json();
      message = data.message || message;
    } catch {
      // ignore parse errors
    }
    throw new Error(message);
  }
  return response.json();
};

export const fetchPrintDashboard = async () => {
  const response = await fetch(`${API_BASE_URL}/PrintQueue/Dashboard`, {
    headers: authHeaders(),
  });
  return handleResponse(response, "Failed to load production dashboard");
};

export const startPrintSession = async () => {
  const response = await fetch(`${API_BASE_URL}/PrintQueue/StartSession`, {
    method: "POST",
    headers: authHeaders(),
  });
  return handleResponse(response, "Failed to start print session");
};

export const fetchAvailablePrintOrders = async (
  page = 0,
  pageSize = 20,
  search = "",
  statuses = []
) => {
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  if (search?.trim()) {
    params.set("search", search.trim());
  }
  if (statuses?.length) {
    params.set("statuses", statuses.join(","));
  }
  const response = await fetch(
    `${API_BASE_URL}/PrintQueue/AvailableOrders?${params.toString()}`,
    { headers: authHeaders() }
  );
  return handleResponse(response, "Failed to load orders");
};

export const addOrdersToPrintQueue = async (orderIds) => {
  const response = await fetch(`${API_BASE_URL}/PrintQueue/AddOrders`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ orderIds }),
  });
  return handleResponse(response, "Failed to add orders to print queue");
};

export const completePrintBatch = async () => {
  const response = await fetch(`${API_BASE_URL}/PrintQueue/CompleteBatch`, {
    method: "POST",
    headers: authHeaders(),
  });
  return handleResponse(response, "Failed to complete batch");
};

export const removePrintQueueItem = async (itemId) => {
  const response = await fetch(`${API_BASE_URL}/PrintQueue/RemoveItem/${itemId}`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  return handleResponse(response, "Failed to remove item");
};

export const refreshPrintBatch = async () => {
  const response = await fetch(`${API_BASE_URL}/PrintQueue/RefreshBatch`, {
    method: "POST",
    headers: authHeaders(),
  });
  return handleResponse(response, "Failed to refresh batch");
};

export const closePrintSession = async () => {
  const response = await fetch(`${API_BASE_URL}/PrintQueue/CloseSession`, {
    method: "POST",
    headers: authHeaders(),
  });
  return handleResponse(response, "Failed to close session");
};

export const fetchPrintedItems = async (page = 0, pageSize = 12) => {
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  const response = await fetch(
    `${API_BASE_URL}/PrintQueue/PrintedItems?${params.toString()}`,
    { headers: authHeaders() }
  );
  return handleResponse(response, "Failed to load printed items");
};

export const reprintPrintItem = async (itemId) => {
  const response = await fetch(`${API_BASE_URL}/PrintQueue/ReprintItem/${itemId}`, {
    method: "POST",
    headers: authHeaders(),
  });
  return handleResponse(response, "Failed to reprint item");
};

export const resetBatchCounter = async () => {
  const response = await fetch(`${API_BASE_URL}/PrintQueue/ResetBatchCounter`, {
    method: "POST",
    headers: authHeaders(),
  });
  return handleResponse(response, "Failed to reset batch counter");
};

export const fetchAllPendingLabels = async () => {
  const response = await fetch(`${API_BASE_URL}/PrintQueue/AllPendingLabels`, {
    headers: authHeaders(),
  });
  return handleResponse(response, "Failed to load pending labels");
};

export const fetchBatchView = async (offset = 0) => {
  const params = new URLSearchParams({ offset: String(offset) });
  const response = await fetch(`${API_BASE_URL}/PrintQueue/BatchView?${params.toString()}`, {
    headers: authHeaders(),
  });
  return handleResponse(response, "Failed to load batch view");
};

export const swapPrintItems = async (itemIdA, itemIdB) => {
  const response = await fetch(`${API_BASE_URL}/PrintQueue/SwapItems`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ itemIdA, itemIdB }),
  });
  return handleResponse(response, "Failed to swap items");
};
